import { useMemo, useState } from 'react';
import { EcosystemListingStub } from 'trellis-ecosystem';
import { AUTOCOMPLETE_QUERY as PUBLIC_AUTOCOMPLETE_QUERY } from '../../../__generated__/chirp/com/hubspot/query/understanding/mkpl/autocomp/rpc/MarketplaceAutocompletePublicRpc.dfc.new';
import { AUTOCOMPLETE_QUERY } from '../../../__generated__/chirp/com/hubspot/query/understanding/mkpl/autocomp/rpc/MarketplaceAutocompleteRpc.dfc.new';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
import { AutocompleteItem } from '../components/AutoCompleteItem';
import { SearchBar } from '../components/SearchBar';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchBarContainer() {
  const [searchTerm, setSearchTerm] = useState('');

  // Use the search hook with the current search term
  const {
    data,
    loading
  } = useAppContextQuery({
    app: AUTOCOMPLETE_QUERY,
    public: PUBLIC_AUTOCOMPLETE_QUERY,
    options: {
      skip: !searchTerm,
      variables: {
        queryTerm: searchTerm,
        language: 'en',
        fallbackLanguage: 'en',
        useSpellingCorrections: true,
        limit: 10
      }
    }
  });

  // Handle input changes
  const handleInputChange = event => {
    setSearchTerm(event.target.value);
  };

  // Handle search submission
  const handleSearchSubmit = value => {
    console.log('Search submitted:', value);
    // TODO: navigate to a search results page
  };

  // Handle dropdown open/close
  const handleOpenChange = isOpen => {
    // TODO: track dropdown state if needed
    console.log('Dropdown open state:', isOpen);
  };

  // Format search results as options for the SearchBar dropdown
  const searchOptions = useMemo(() => {
    const options = [];
    const seenTerms = new Set();
    let firstSpellingCorrection = '';

    // Add spelling corrections if available
    if (data !== null && data !== void 0 && data.result.spellingCorrections && data.result.spellingCorrections.length > 0) {
      data.result.spellingCorrections.forEach(correction => {
        if (!seenTerms.has(correction)) {
          seenTerms.add(correction);
          // Store the first spelling correction
          if (!firstSpellingCorrection) {
            firstSpellingCorrection = correction;
          }
          options.push( /*#__PURE__*/_jsx(AutocompleteItem, {
            keyword: correction,
            suggestion: correction
          }, correction));
        }
      });
    }

    // Add autocomplete results
    if (data !== null && data !== void 0 && data.result.autocompleteResultItems) {
      data.result.autocompleteResultItems.forEach(item => {
        // Handle different result types
        if (item.resultType === 'QUERY') {
          // For QUERY type, use AutoCompleteItem component
          if (!seenTerms.has(item.term)) {
            seenTerms.add(item.term);
            options.push( /*#__PURE__*/_jsx(AutocompleteItem, {
              keyword: firstSpellingCorrection || searchTerm,
              suggestion: item.term
            }, `query-${item.term}`));
          }
        } else if (item.resultType === 'LISTING') {
          // For LISTING type, create an EcosystemListingStub component
          if (!seenTerms.has(item.term || '')) {
            seenTerms.add(item.term || '');
            options.push( /*#__PURE__*/_jsx(EcosystemListingStub, {
              imageSrc: item.iconUrl || '',
              name: item.term || '',
              productType: item.productType || 'APP',
              providerName: item.providerName || ''
            }, item.slug));
          }
        }
      });
    }
    return options;
  }, [data, searchTerm]);
  return /*#__PURE__*/_jsx(SearchBar, {
    inputValue: searchTerm,
    isLoading: loading,
    minSearchLength: 2,
    onInputValueChange: handleInputChange,
    onSearchSubmit: handleSearchSubmit,
    onOpenChange: handleOpenChange,
    options: searchOptions,
    use: "on-dark"
  });
}